/**
 * clase de utilidad con regex comunes
 */
export default function useRegexConstants() {
  /**
   * Regex usada para campos con Nombres y apellidos, admite letras, admite espacios, y varios valores comunes en nombres, como
   * pueden ser guiones, tildes y acentos internacionales.
   *
   * @type {RegExp} regex
   */
  const REGEX_VALID_NOMBRE =
    /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆŠŽ∂ð ,.'-]+$/u;

  /**
   * Regex usada para validacion de teléfonos.
   * Los valores coinciden non un solo carácter en el rango entre 0 y 9
   * Los valores coinciden con un solo carácter de la lista + -
   *
   * @type {RegExp}
   */
  const REGEX_VALID_TELEFONO = /^[0-9+-]+$/;

  /**
   * Regex usada para validacion de corres electrónicos
   *
   * @type {RegExp}
   */
  const REGEX_VALID_EMAIL =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return {
    REGEX_VALID_NOMBRE,
    REGEX_VALID_TELEFONO,
    REGEX_VALID_EMAIL,
  };
}
